import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const SettingsIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "m15.716 7.504-3.429-6A.996.996 0 0 0 11.42 1H4.58a.999.999 0 0 0-.868.504l-3.429 6a.998.998 0 0 0 0 .992l3.429 6A.999.999 0 0 0 4.58 15h6.839c.359 0 .69-.192.868-.504l3.429-6a.998.998 0 0 0 0-.992ZM8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z", fill: "currentColor" })));
});
SettingsIcon.displayName = 'SettingsIcon';
export default SettingsIcon;
